'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en = require('i2l?query=sporks!../../../../lang/en.lyaml');

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Provider) {
  return Provider.register(_en2.default);
};

module.exports = exports['default'];